/* eslint-disable react/display-name */
// react
import React, { useState, useEffect } from 'react'
import { CSVLink } from 'react-csv'

// components
import { Button, BUTTON_THEME } from '@st-operations/uikit/src/v2/index.js'
import ListView from '_components/list-view/index.jsx'
import Header from '_components/header/index.jsx'

// Styles
import './styles.scss'

const ChangeLog = (props) => {
  let addedString = ''
  let added = props?.values?.added || []
  added.forEach((value) => {
    addedString += `+ ${value} `
  })

  let removedString = ''
  let removed = props?.values?.removed || []
  removed.forEach((value) => {
    removedString += `- ${value} `
  })

  return (
    <If condition={props.values?.added?.length || props.values?.removed?.length}>
      <div className="content-rule-logs__change-log">
        <span>{props.title}: </span>
        <div className="content-rule-logs__change-log-added">{addedString}</div>
        <div className="content-rule-logs__change-log-removed">{removedString}</div>
      </div>
    </If>
  )
}

const ContentRuleLogs = () => {
  const [contentRules, setContentRules] = useState([])
  const [createdBy, setCreatedBy] = useState([])
  const [contentRuleLogsData, setContentRuleLogsData] = useState([])

  useEffect(() => {
    const getCreatedBy = async () => {
      window._api.get('/content-rule-logs/enum/created_by.email', (error, items) => {
        if (error) {
          toast.error(error.message)
        } else {
          setCreatedBy(items)
        }
      })
    }
    getCreatedBy()
  }, [])

  useEffect(() => {
    const getContentRules = async () => {
      window._api.get('/content-rule-logs/enum/content_rule.name', (error, items) => {
        if (error) {
          toast.error(error.message)
        } else {
          setContentRules(items)
        }
      })
    }
    getContentRules()
  }, [])

  let dataToDownload = contentRuleLogsData?.map((content) => {
    const { content_rule, message, created_by, created_at, tokens, actions, regions } = content
    return {
      contentRule: content_rule.name,
      message,
      createdBy: created_by.email,
      createdAt: created_at,
      tokensAdded: tokens.added,
      tokkensRemoved: tokens.removed,
      actionsAdded: actions.added,
      actionsRemoved: actions.removed,
      regionsAdded: regions.added,
      regionsRemoved: regions.removed,
    }
  })
  const dataToDownloadOrdered = dataToDownload?.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  )

  let headers = [
    { label: 'Content Rule', key: 'contentRule' },
    { label: 'Message', key: 'message' },
    { label: 'Created By', key: 'createdBy' },
    { label: 'Created At', key: 'createdAt' },
    { label: 'Tokens Added', key: 'tokensAdded' },
    { label: 'Tokens Removed', key: 'tokkensRemoved' },
    { label: 'Actions Added', key: 'actionsAdded' },
    { label: 'Actions Removed', key: 'actionsRemoved' },
    { label: 'Regions Added', key: 'regionsAdded' },
    { label: 'Regions Removed', key: 'regionsRemoved' },
  ]

  const csvReport = {
    filename: 'content-rule-logs.csv',
    headers,
    data: dataToDownloadOrdered ? dataToDownloadOrdered : [],
  }

  const handleGetItems = (items) => {
    setContentRuleLogsData(items)
  }

  return (
    <div id="content-rule-logs-page" className="content-rule-logs">
      <Header>
        <div className="content-rule-logs__header">
          <h1 className="title">Content Rule Logs</h1>
          <CSVLink {...csvReport}>
            <Button theme={BUTTON_THEME.PRIMARY}>Download as CSV</Button>
          </CSVLink>
        </div>
      </Header>
      <ListView
        columns={[
          {
            name: 'Content Rule',
            key: 'content_rule.name',
            sortable: true,
            styles: { maxWidth: '125px' },
          },
          {
            name: 'Message',
            key: 'message',
            sortable: true,
            styles: {
              maxWidth: '300px',
              textAlign: 'left',
            },
          },
          {
            name: 'Changes',
            render: (item) => {
              return (
                <div>
                  <ChangeLog title="Tokens" values={item?.tokens} />
                  <ChangeLog title="Actions" values={item?.actions} />
                  <ChangeLog title="Regions" values={item?.regions} />
                </div>
              )
            },
            styles: {
              minWidth: '300px',
              textAlign: 'left',
            },
          },
          {
            name: 'Created By',
            key: 'created_by.email',
            sortable: true,
            styles: { maxWidth: '200px' },
          },
          {
            key: 'created_at',
            name: 'Created At',
            sortable: true,
            styles: { maxWidth: '200px' },
          },
        ]}
        entities="content-rule-logs"
        fields={[
          'content_rule.name',
          'message',
          'created_by.email',
          'created_at',
          'tokens',
          'actions',
          'regions',
        ]}
        filters={[
          {
            name: 'content_rule.name',
            label: 'Content Rule',
            options: contentRules,
            all: true,
          },
          {
            name: 'created_by.email',
            label: 'Created By',
            options: createdBy,
            all: true,
          },
          {
            name: 'from',
            label: 'From',
            type: 'date',
          },
          {
            name: 'to',
            label: 'To',
            type: 'date',
          },
        ]}
        searchable={true}
        sort_dir={-1}
        sort_key={'created_at'}
        onGetItems={handleGetItems}
      />
    </div>
  )
}

// export
export default ContentRuleLogs
